<template>
  <div class="subcheo-banner">
    <div class="banner-content">
      <a
        v-for="packageItem in followPackages"
        :key="packageItem.id"
        :href="packageItem.checkoutUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="follow-card"
        :class="{ 'follow-card-hot': packageItem.isHot }"
      >
        <div v-if="packageItem.isHot" class="hot-badge">HOT</div>
        <div class="follow-main">
          <div class="follow-info">
            <div class="follow-badge">{{ packageItem.id }}</div>
            <div class="follow-title-group">
              <div class="follow-title">{{ packageItem.title }}</div>
              <div class="follow-subtitle">{{ packageItem.subTitle }}</div>
            </div>
          </div>
          <div class="follow-prices">
            <div class="follow-price-original">
              <s>{{ formatPrice(packageItem.originalPrice) }}</s>
            </div>
            <div
              class="follow-price"
              :class="{ 'follow-price-large': packageItem.isLargePrice }"
            >
              {{ formatPrice(packageItem.salePrice) }}
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { getFollowPackages } from '../api/utils/pricing';

export default {
  name: 'SubcheoBanner',

  data() {
    return {
      followPackages: [
        {
          id: 'Gói F1',
          title: 'Tăng 1.000 Shopee Follow',
          subTitle: 'Tăng uy tín Shop, cam kết an toàn không tụt Follow',
          originalPrice: 150000,
          salePrice: 130000,
          isHot: false,
          isLargePrice: false,
          checkoutUrl: 'https://subcheo.vn/#pricing',
        },
        {
          id: 'Gói F2',
          title: 'Tăng 2.000 Shopee Follow',
          subTitle: 'Tăng uy tín Shop, cam kết an toàn không tụt Follow',
          originalPrice: 250000,
          salePrice: 220000,
          isHot: false,
          isLargePrice: false,
          checkoutUrl: 'https://subcheo.vn/#pricing',
        },
        {
          id: 'Gói F5',
          title: 'Tăng 5.000 Shopee Follow',
          subTitle: 'Tăng uy tín Shop, cam kết an toàn không tụt Follow',
          originalPrice: 500000,
          salePrice: 400000,
          isHot: true,
          isLargePrice: true,
          checkoutUrl: 'https://subcheo.vn/#pricing',
        },
        {
          id: 'Gói F10',
          title: 'Tăng 10k Shopee Follow',
          subTitle: 'Tăng uy tín Shop, cam kết an toàn không tụt Follow',
          originalPrice: 900000,
          salePrice: 600000,
          isHot: true,
          isLargePrice: true,
          checkoutUrl: 'https://subcheo.vn/#pricing',
        },
        {
          id: 'Gói F20',
          title: 'Tăng 20k Shopee Follow',
          subTitle: 'Tăng uy tín Shop, cam kết an toàn không tụt Follow',
          originalPrice: 1600000,
          salePrice: 1000000,
          isHot: true,
          isLargePrice: true,
          checkoutUrl: 'https://subcheo.vn/#pricing',
        },
      ],
    };
  },

  async created() {
    try {
      const followPackages = await getFollowPackages();
      if (followPackages.length) {
        this.followPackages = followPackages;
      } else {
        throw new Error('CMS_FOLLOW_EMPTY');
      }
    } catch (error) {
      console.error({
        msg: 'CMS_FOLLOW_FALLBACK',
        error,
      });
    }
  },

  methods: {
    formatPrice(price) {
      return `${new Intl.NumberFormat('vi-VN').format(price)}đ`;
    },
  },
};
</script>

<style scoped>
.subcheo-banner {
  width: 100%;
}

.banner-content {
  padding: var(--spacing-md);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--spacing-md);
}

.follow-card {
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-lg);
  background: var(--bg-primary);
  position: relative;
  transition: border-color var(--transition-base);
  color: inherit;
  text-decoration: none;
}

.follow-card:hover {
  border-color: var(--primary-color);
}

.follow-card:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}

.follow-card-hot {
  border-color: var(--primary-color);
  background: var(--primary-light);
}

.follow-card-hot .follow-subtitle,
.follow-card-hot .follow-price-original {
  color: var(--text-secondary);
}

.hot-badge {
  position: absolute;
  top: -10px;
  left: 12px;
  background: var(--primary-color);
  color: var(--text-inverse);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xs);
  letter-spacing: 0.04em;
  padding: 3px 8px;
  border-radius: var(--border-radius-full);
  z-index: 1;
}

.follow-main {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.follow-info {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-sm);
}

.follow-badge {
  flex-shrink: 0;
  padding: 4px 10px;
  border-radius: var(--border-radius-md);
  background: var(--primary-color);
  color: var(--text-inverse);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  min-width: 36px;
  text-align: center;
}

.follow-title-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.follow-title {
  font-size: var(--font-size-base);
  color: var(--text-primary);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-tight);
}

.follow-subtitle {
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
  line-height: var(--line-height-normal);
}

.follow-prices {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--spacing-sm);
}

.follow-price-original {
  font-size: var(--font-size-sm);
  color: var(--text-tertiary);
}

.follow-price-original s {
  color: var(--text-disabled);
}

.follow-price {
  font-size: var(--font-size-xl);
  letter-spacing: -0.01em;
  color: var(--text-primary);
  font-weight: var(--font-weight-bold);
}

.follow-price-large {
  font-size: var(--font-size-2xl);
}

@media (max-width: 768px) {
  .banner-content {
    padding: var(--spacing-sm);
    grid-template-columns: 1fr;
    gap: var(--spacing-sm);
  }

  .follow-card {
    padding: var(--spacing-md);
  }

  .follow-main {
    gap: var(--spacing-sm);
  }

  .follow-badge {
    font-size: var(--font-size-xs);
    padding: 3px 8px;
    min-width: 32px;
  }

  .follow-title {
    font-size: var(--font-size-sm);
  }

  .follow-subtitle {
    font-size: 10px;
  }

  .follow-price-original {
    font-size: var(--font-size-xs);
  }

  .follow-price {
    font-size: var(--font-size-lg);
  }

  .follow-price-large {
    font-size: var(--font-size-xl);
  }

  .hot-badge {
    top: -8px;
    font-size: 10px;
    padding: 3px 8px;
  }
}

@media (max-width: 480px) {
  .banner-content {
    padding: var(--spacing-xs);
  }

  .follow-card {
    padding: var(--spacing-sm);
  }

  .follow-title {
    font-size: var(--font-size-xs);
  }

  .follow-subtitle {
    font-size: 9px;
  }

  .follow-price {
    font-size: var(--font-size-base);
  }

  .follow-price-large {
    font-size: var(--font-size-lg);
  }
}
</style>
